export default __webpack_public_path__ + "dd6f0e5599a89e9e02147050401ce40e.gif";